import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Mic } from "lucide-react";
import { Reveal, RevealLine } from "../lib/motion";
import { INSIGHTS as FALLBACK_INSIGHTS, SPEAKING as FALLBACK_SPEAKING } from "../data";
import { http, mediaUrl } from "../lib/api";

const fmtDate = (s) => { if (!s) return ""; try { return new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }); } catch { return s; } };

export const Insights = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { http.get("/insights").then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, []);

  const dynamic = items && items.length > 0;
  const list = dynamic ? items : FALLBACK_INSIGHTS;

  return (
    <section id="insights" data-testid="insights-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="max-w-2xl mb-16">
          <div className="overline mb-6">Insights</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-tight text-[var(--ink)]">
            <RevealLine>Idee e prospettive</RevealLine>
            <RevealLine delay={0.08} className="italic text-[var(--petrol)]">dal board.</RevealLine>
          </h2>
        </div>

        <div className="border-t border-[var(--line)]">
          {list.map((a, i) => {
            const href = dynamic ? (a.external_link || `/insights/${a.slug}`) : "#contatti";
            const external = dynamic && !!a.external_link;
            const inner = (
              <>
                <span className="md:col-span-3 text-xs uppercase tracking-[0.15em] text-[var(--accent)]">{dynamic ? a.category : a.tag}</span>
                <h3 className="md:col-span-6 font-serif text-2xl sm:text-3xl text-[var(--ink)]">{a.title}</h3>
                <div className="md:col-span-3 flex items-center justify-between md:justify-end gap-3 text-[var(--ink-soft)]">
                  <span className="text-sm">{dynamic ? fmtDate(a.date) : a.read}</span>
                  <ArrowUpRight size={18} strokeWidth={1.5} className="group-hover:rotate-45 transition-transform duration-400" />
                </div>
              </>
            );
            const cls = "group grid md:grid-cols-12 gap-4 items-center py-8 border-b border-[var(--line)] hover:px-3 transition-[padding] duration-400";
            return (
              <Reveal key={a.id || i} delay={i * 0.05}>
                {external
                  ? <a href={href} target="_blank" rel="noreferrer" data-testid={`insight-${i}`} className={cls}>{inner}</a>
                  : dynamic
                    ? <Link to={href} data-testid={`insight-${i}`} className={cls}>{inner}</Link>
                    : <a href={href} data-testid={`insight-${i}`} className={cls}>{inner}</a>}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export const Speaking = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { http.get("/speaking").then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, []);

  const dynamic = items && items.length > 0;
  const list = dynamic ? items : FALLBACK_SPEAKING;

  return (
    <section id="speaking" data-testid="speaking-section" className="py-24 sm:py-32 bg-[var(--petrol)] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex items-center gap-3 overline !text-white/70 mb-6"><Mic size={16} strokeWidth={1.5} /> Speaking</div>
        <h2 className="font-serif text-4xl sm:text-5xl leading-tight mb-14 max-w-2xl">
          <RevealLine>Sul palco dei principali</RevealLine>
          <RevealLine delay={0.08} className="italic">forum executive.</RevealLine>
        </h2>
        <div className="grid md:grid-cols-3 gap-px bg-white/15 border border-white/15">
          {list.map((s, i) => (
            <Reveal key={s.id || i} delay={i * 0.08} className="bg-[var(--petrol)] p-8">
              {dynamic && s.photo_file_id && (
                <div className="aspect-video overflow-hidden mb-5 -mx-8 -mt-8"><img src={mediaUrl(s.photo_file_id)} alt={s.event_name} className="w-full h-full object-cover" /></div>
              )}
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs uppercase tracking-[0.15em] text-white/60">{dynamic ? s.location : s.place}</span>
                {dynamic && <span className="text-[0.6rem] uppercase tracking-[0.15em] px-2 py-0.5 border border-white/30 text-white/70">{s.status === "past" ? "Past" : "Upcoming"}</span>}
              </div>
              <h3 className="font-serif text-2xl mb-2">{dynamic ? s.event_name : s.event}</h3>
              <p className="text-white/70">{s.role}{dynamic && s.talk_title ? ` · ${s.talk_title}` : ""}</p>
              {dynamic && s.official_link && <a href={s.official_link} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1 text-xs uppercase tracking-[0.12em] text-white/80 link-underline">Dettagli <ArrowUpRight size={13} /></a>}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
